import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import videoIcon from "./../../assets/images/icon-see-dentist.svg";
import phoneIcon from "./../../assets/images/Phone.svg";
import { setSeeDentistCallOptions } from "../../redux/actions/userData";

const SeeDentistOptionsForm = () => {
  const iconStyle = {
    maxWidth: "75px",
    height: "auto",
    width: "48px",
    objectFit: "contain"
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isCallTypeVideoCall, setIsCallTypeVideoCall] = useState(null);

  const handleOptionChange = (e) => {
    const selected = e.target.value === "phone-call";
    
    setIsCallTypeVideoCall(selected);
    dispatch(setSeeDentistCallOptions(selected));
  };

  const handleNext = () => {
    if (isCallTypeVideoCall !== null) {
      const currentParams = location.search;

      navigate(`/see-dentist${currentParams}`, {
        state: { isCallTypeVideoCall }
      });
    }
  };

  return (
    <div>
      <div className="tab-content" id="step-tabContent">
        <div
          className="tab-pane fade show active"
          id="call-option"
          role="tabpanel"
          aria-labelledby="call-option-tab"
        >
          <form>
            <fieldset>
              <legend className="fs-1 mb-0 visually-hidden">
                Connection Options
              </legend>
              <div className="form-group mt-4 mb-3 col-md-6">
                <div className="form-group-title fs-3 text-violet mb-2 mb-md-3 lh-1">
                  How would you like to connect?
                </div>
                <div className="form-check mb-4 ms-auto me-4 d-block">
                  <input
                    className="form-check-input callOptions-radio mt-2"
                    type="radio"
                    name="callOptions"
                    id="video-call"
                    value="video-call"
                    onChange={handleOptionChange}
                  />
                  <label
                    className="form-check-label align-items-center fs-4"
                    htmlFor="video-call"
                  >
                    <img
                      src={videoIcon}
                      alt="Video call icon"
                      className="call-option-icon me-3"
                      style={iconStyle}
                    />
                    Video call
                  </label>
                </div>
                <div className="form-check mb-2 me-4 d-block">
                  <input
                    className="form-check-input callOptions-radio mt-2"
                    type="radio"
                    name="callOptions"
                    id="phone-call"
                    value="phone-call"
                    onChange={handleOptionChange}
                  />
                  <label
                    className="form-check-label align-items-center fs-4"
                    htmlFor="phone-call"
                  >
                    <img
                      src={phoneIcon}
                      alt="Phone call icon"
                      className="call-option-icon me-3"
                      style={iconStyle}
                    />
                    Phone call
                  </label>
                </div>
              </div>
              <div className="form-group text-center mt-2 mt-md-4 col-sm-12 button-wrapper">
                <Link
                  to="/dashboard"
                  className="btn btn-outline btn-rounded btn-lg px-5 mx-md-2 mt-3 mt-md-0"
                >
                  Cancel
                </Link>
                <button
                  type="button"
                  className="btn btn-secondary btn-rounded btn-lg px-5 mx-md-2 mt-3 mt-md-0 next-btn"
                  onClick={handleNext}
                  disabled={isCallTypeVideoCall === null}
                >
                  Next
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SeeDentistOptionsForm;
